
import { BannerManageImpl } from '@/commons/bannerManage'
import { BannerService } from '@/commons/bannerService'
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class extends Vue {
  private manager = new BannerManageImpl(new BannerService())

  mounted () {
    this.manager.requestBannerList()
  }

  goLinkpage (url: string) {
    console.log(url)
    if (!url) { return }
    if (!url.includes('http://') && !url.includes('https://')) {
      url = 'https://' + url
    }
    window.open(url)
  }
}
